import { AxiosResponse } from 'axios';
import qs from 'qs';

import { calcPageCount } from '../../../molecules/Pagination/selectors';
import { calculatePageFromOffsetLimit } from '../../../molecules/Pagination/utils';
import History from '../../history';
import attachParamsToUrl from '../../routeParameterAttacher';
import { getTotalFromHeader } from '../utils';

/**
 * @deprecated this interceptor allows XS-search attack, so it will be deleted.
 * It is no longer needed if the project is only using useRQListApi or
 * useListApi hooks for any paginated lists.
 */
export const emptyListResponsePrevPageRedirect = (response: AxiosResponse) => {
  const { config } = response;

  // If request doesnt have pagination params
  if (!config?.params?.limit || !config?.params?.offset) {
    return response;
  }

  const {
    params: { limit, offset },
  } = config;

  const page = calculatePageFromOffsetLimit(offset, limit);

  // If is first page or response is not array
  if (page === 0 || Array.isArray(response.data) === false || response.data?.length) {
    return response;
  }

  const {
    location: { pathname, search },
    push,
  } = History;
  const total = getTotalFromHeader(response.headers);
  const lastPage = calcPageCount(total, limit) - 1;

  if (page === lastPage) {
    return response;
  }

  const parsedParams = qs.parse(search, { ignoreQueryPrefix: true });

  // Redirect to last page or remove page param
  push(
    attachParamsToUrl({
      params: {
        ...parsedParams,
        page: lastPage && lastPage > 0 ? lastPage : undefined,
      },
      url: pathname,
    })
  );

  return response;
};
